import { AbstractControl, ValidationErrors } from '@angular/forms';

export function confirmPassword(control: AbstractControl): ValidationErrors | null {
  if (!control.parent) {
    return null;
  }

  const passwordControl = control.parent.get('password');
  if (!passwordControl) {
    return null;
  }
  if (passwordControl.value === control.value) {
    return null;
  }
  return { confirmPassword: true };
}
